export default (firstName: string, lastName: string): string =>
  firstName.substr(0, 1).toUpperCase() + lastName.substr(0, 1).toUpperCase()
